import { useEffect, useState } from "react";
import classNames from "classnames";
import { Typography } from "components/atoms";
import { Tab } from "components/molecules/Tab";
import { TabPracticeContent } from "components/organisms/TabPracticeContent";
import { MobileTextIcon } from "components/molecules/MobileTextIcon";
import { DropDown } from "components/atoms";
import { useAppSelector, useAppDispatch, useScreenSize } from "hooks";
import {
  useGetPracticeTestsQuery,
  useGetTestResultsQuery,
} from "services/practice";
import {
  DASHBOARD_PROGRAME,
  DESKTOP_WIDTH,
  LSAT_TEST_TYPE,
  MCAT_TEST_TYPE,
  MOBILE_WIDTH,
  SELF_PACED_PROGRAME,
} from "utils/constants";
import { CloseIcon, Spinner } from "components/atoms/Icon";
import { FetchError, Modal, RefreshModal } from "components/molecules";
import { useNavigate } from "react-router-dom";
import { ai_mcat_chat_status } from "state/reducers/layoutSlice";
import {
  useGetCourseworkQuery,
  useGetOverallProgressQuery,
  useGetTestScoresAndPerformanceQuery,
} from "services/homeApi";
import { getObjectKeysByValue } from "services/helpers";
import { getTimeFilterInput } from "utils/functions/getTimeFilterInput";
import { useSegmentReFetch } from "context";
import { decodeToken } from "utils/functions/decodeToken";
import { PracticeModalInnerCard } from "../PracticeModalInnerCard";
import { openExternalUrl } from "utils/functions/openExternalUrl";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  isTabShow: boolean;
  styles?: string;
  title: string;
  description: string;
}

export const PracticeDetailCard = ({
  theme,
  title,
  isTabShow,
  description,
}: IProps) => {
  const [mobileDropDownValue, setMobileDropDownValue] = useState<
    null | string | { [key: number]: string }
  >(null);
  const [secondMobileDropDownValue, setSecondMobileDropDownValue] = useState<
    null | string | { [key: number]: string }
  >(null);
  const [isRequiredShow, setIsRequiredShow] = useState(true);
  const [isFullLengthShow, setIsFullLengthShow] = useState(false);
  const [isSingleSectionShow, setIsSingleSectionShow] = useState(false);
  const [isAamcShow, setIsAamcShow] = useState(false);
  const [isFullLengthFilterSet, setIsFullLengthFilterSet] = useState(false);
  const [isSingleSectionFilterSet, setIsSingleSectionFilterSet] =
    useState(false);
  const [secondDropDownValue, setSecondDropDownValue] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalSelector, setModalSelector] = useState<"both" | "paper & pencil">(
    "both"
  );
  const [selectedItem, setSelectedItem] = useState<any>("");
  const [bubbleSheeetPdfUrl, setBubbleSheetPdfUrl] = useState("");

  const [onlineProctor_1, setOnlineProctor_1] = useState("");
  const [onlineProctor_2, setOnlineProctor_2] = useState("");
  const [onlineProctor_3, setOnlineProctor_3] = useState("");

  const screen = useScreenSize();
  const navigate = useNavigate();
  const payload = decodeToken();
  const dispatch = useAppDispatch();
  const { selectedBtn, selectedSession, page, subject } = useSegmentReFetch();

  const userId = payload ? payload.userid : null;
  const productCode = payload ? payload.productcode : null;
  const offeringCode = payload ? payload.offeringcode : null;

  const isDashboard =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === DASHBOARD_PROGRAME;

  const isSelfPaced =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === SELF_PACED_PROGRAME;

  const testtype =
    payload && payload.hasOwnProperty("testtype") && payload.testtype;

  const {
    data: PracticeTestData,
    isLoading: PracticeTestIsLoading,
    isError: PracticeTestIsError,
    isFetching: PracticeTestIsFetching,
    refetch: PracticeTestRefetch,
  } = useGetPracticeTestsQuery();

  const { isFetching: graphDataIsFetching, refetch: graphDataReFetch } =
    useGetTestResultsQuery();

  const { refetch: refetchTestScores, isFetching: isfetchingTestScores } =
    useGetTestScoresAndPerformanceQuery();

  const {
    refetch: refetchOverAllProgress,
    isFetching: isFetchingOverallProgress,
  } = useGetOverallProgressQuery({
    Userid: userId,
    Productcode: productCode,
    Offeringcode: offeringCode,
  });

  const { refetch: refetchCoursework, isFetching: isFetchingCoursework } =
    useGetCourseworkQuery({
      page: page,
      ...(isDashboard
        ? {
            selectedOption: parseInt(
              getObjectKeysByValue(selectedBtn, true)[0],
              10
            ),
          }
        : {}),
      ...(isDashboard
        ? {
      timeFilter:
        selectedSession === null
          ? 1
          : getTimeFilterInput(Object.values(selectedSession)[0]),
          }
        : {}),
      ...(isSelfPaced && testtype === MCAT_TEST_TYPE
        ? {
            subject: subject,
          }
        : {}),
    });

  const { aiMCATChatDrawerStatus } = useAppSelector(
    (state: { layout: { aiMCATChatDrawerStatus: ai_mcat_chat_status } }) =>
      state.layout
  );

  let hasSmallScreenWithChatDrawerOpen =
    screen.width > DESKTOP_WIDTH &&
    screen.width < 1600 &&
    aiMCATChatDrawerStatus === "open";

  const extractTabTitle = (data: any) => {
    return Object.keys(data)
      .filter(
        (category: string) =>
          data[category] &&
          Array.isArray(data[category]) &&
          data[category].length > 0
      )
      .map((val: string) => {
        switch (val) {
          case "RequiredTests":
            return payload &&
              payload.hasOwnProperty("programtype") &&
              payload.programtype === SELF_PACED_PROGRAME &&
              payload.testtype === LSAT_TEST_TYPE
              ? "Primary Tests"
              : "Required Tests";

          case "FullLengthTests":
            return "Full Length Supplemental Tests";
          case "SingleSectionTests":
            return "Single Section Tests";
          case "AamcTests":
            return "AAMC Tests";
          default:
            return "";
        }
      });
  };

  const [isRefreshModalOpen, setIsRefreshModalOpen] = useState({
    isOpen: false,
    data: "",
  });

  const handleRefresh = async () => {
    await PracticeTestRefetch();
    await graphDataReFetch();
    await refetchOverAllProgress();
    await refetchTestScores();
    await refetchCoursework();
    handleRefreshModalClose();
  };

  const handleRefreshModalClose = () => {
    setIsRefreshModalOpen((prev) => ({ ...prev, isOpen: false, data: "" }));
  };

  const handleRefreshModalOpen = (contentObjectType?: any) => {
    setIsRefreshModalOpen((prev) => ({
      ...prev,
      isOpen: true,
      data: contentObjectType,
    }));
  };

  const handlePracticeTestExecution = (item: any) => {
    setSelectedItem(item);
    switch (item.LaunchTests.length) {
      case 2:
        setModalSelector("both");
        setBubbleSheetPdfUrl(item.PdfUrl);
        setIsModalOpen(true);

        if (item.LaunchTests[0].DeliveryType === "Online") {
          if (item.LaunchTests[1].ProctorUrl) {
            setOnlineProctor_1(
              item.LaunchTests[1].ProctorUrl["Online Proctor"]
            );
            setOnlineProctor_2(
              item.LaunchTests[1].ProctorUrl["Online Proctor 1.5x Timer"]
            );
            setOnlineProctor_3(
              item.LaunchTests[1].ProctorUrl["Online Proctor 2x Timer"]
            );
          }
        } else {
          if (item.LaunchTests[0].ProctorUrl) {
            setOnlineProctor_1(
              item.LaunchTests[0].ProctorUrl["Online Proctor"]
            );
            setOnlineProctor_2(
              item.LaunchTests[0].ProctorUrl["Online Proctor 1.5x Timer"]
            );
            setOnlineProctor_3(
              item.LaunchTests[0].ProctorUrl["Online Proctor 2x Timer"]
            );
          }
        }

        break;
      case 1:
        if (item.LaunchTests[0].DeliveryType === "Online") {
          if (item.LaunchTests[0].LaunchUrl) {
            openExternalUrl({
              url: item.LaunchTests[0].LaunchUrl,
              contentObjectType: item.ContentObjectType,
              testType: testtype,
              dispatch,
              onRefreshModalOpen: handleRefreshModalOpen,
            });
          }
        } else {
          setModalSelector("paper & pencil");
          setBubbleSheetPdfUrl(item.PdfUrl);

          if (item.LaunchTests[0].ProctorUrl) {
            setOnlineProctor_1(
              item.LaunchTests[0].ProctorUrl["Online Proctor"]
            );
            setOnlineProctor_2(
              item.LaunchTests[0].ProctorUrl["Online Proctor 1.5x Timer"]
            );
            setOnlineProctor_3(
              item.LaunchTests[0].ProctorUrl["Online Proctor 2x Timer"]
            );
          }
          setIsModalOpen(true);
        }
        break;
      default:
        break;
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleMobileTest = (item: any) => {
    if (item.IsLocked === true) {
      navigate("/self-paced/unlock");
  } else if (
      item.LaunchTests.length === 1 &&
      item.LaunchTests[0].DeliveryType === "Online"
    ) {
      openExternalUrl({
        url: item.LaunchTests[0].LaunchUrl,
        contentObjectType: item.ContentObjectType,
        testType: testtype,
        dispatch,
        onRefreshModalOpen: handleRefreshModalOpen,
      });
    } else if (
      (item.LaunchTests.length === 1 &&
        item.LaunchTests[0].DeliveryType !== "Online") ||
      item.LaunchTests.length > 1
    ) {
      if (hasSmallScreenWithChatDrawerOpen) {
        handlePracticeTestExecution(item.ContentObjectType);
      } else {
        navigate("/launch-practice-test", { state: { item: item } });
      }
    }
  };

  useEffect(() => {
    if (
      mobileDropDownValue !== null &&
      typeof mobileDropDownValue === "object"
    ) {
      Object.entries(mobileDropDownValue).forEach(([key, value]) => {
        switch (value) {
          case "Required Tests":
            setIsRequiredShow(true);
            setIsFullLengthShow(false);
            setIsAamcShow(false);
            setIsSingleSectionShow(false);
            setIsSingleSectionFilterSet(false);
            setIsFullLengthFilterSet(false);
            setSecondDropDownValue("");
            break;
          case "Full Length Supplemental Tests":
            setIsRequiredShow(false);
            setIsFullLengthShow(true);
            setIsAamcShow(false);
            setIsSingleSectionShow(false);
            setIsSingleSectionFilterSet(false);
            setIsFullLengthFilterSet(false);
            setSecondDropDownValue("");
            break;
          case "Single Section Tests":
            setIsRequiredShow(false);
            setIsFullLengthShow(false);
            setIsAamcShow(false);
            setIsSingleSectionShow(true);
            setIsSingleSectionFilterSet(false);
            setIsFullLengthFilterSet(false);
            setSecondDropDownValue("");
            break;
          case "AAMC Tests":
            setIsRequiredShow(false);
            setIsFullLengthShow(false);
            setIsAamcShow(true);
            setIsSingleSectionShow(false);
            setIsSingleSectionFilterSet(false);
            setIsFullLengthFilterSet(false);
            setSecondDropDownValue("");
            break;
          default:
            break;
        }
      });
    }
  }, [mobileDropDownValue]);

  useEffect(() => {
    if (
      secondMobileDropDownValue !== null &&
      typeof secondMobileDropDownValue === "object"
    ) {
      Object.entries(secondMobileDropDownValue).forEach(([key, value]) => {
        if (isFullLengthShow) {
          setIsFullLengthFilterSet(true);
          setIsSingleSectionFilterSet(false);
          setSecondDropDownValue(value);

          if (value.length > 18) {
            setSecondMobileDropDownValue(value.substring(0, 18));
          }
        }

        if (isSingleSectionShow) {
          setIsFullLengthFilterSet(false);
          setIsSingleSectionFilterSet(true);
          setSecondDropDownValue(value);

          if (value.length > 18) {
            setSecondMobileDropDownValue(value.substring(0, 18));
          }
        }
      });
    }
  }, [secondMobileDropDownValue]);

  useEffect(() => {
    if (!PracticeTestData) {
      setMobileDropDownValue(null);
      return;
    }
    const tabTitles = extractTabTitle(PracticeTestData);
    const firstTitle = tabTitles?.[0];

    setMobileDropDownValue((prev) => {
      if (prev == null) {
        return firstTitle != null ? { 0: firstTitle } : null;
      }
      const currentValue =
        typeof prev === "object" ? Object.values(prev)[0] : prev;
      const stillValid =
        Array.isArray(tabTitles) &&
        (tabTitles as string[]).includes(currentValue as string);
      return stillValid ? prev : (firstTitle != null ? { 0: firstTitle } : null);
    });
  }, [PracticeTestData]);

  return (
    <>
      <div
        className={classNames(
          "practice-tile-wrapper",
          !PracticeTestIsLoading &&
            !PracticeTestIsError &&
            "default-border-yellow"
        )}
      >
        {PracticeTestIsLoading ? (
          <Spinner theme={theme} />
        ) : PracticeTestIsError ? (
          <div className={classNames("error-text-container")}>
            <FetchError content="Oops! failed to load resources." />
          </div>
        ) : (
          PracticeTestData && (
            <>
              <div className="practice-title-section-wrapper">
                <div className="title-section">
                  <Typography label={title} variant="h5Bold" />
                </div>
                <div className="paragraph-section">
                  <Typography label={description} variant="h8Book" />
                </div>
              </div>
              {screen.width <= 685 || hasSmallScreenWithChatDrawerOpen ? (
                isTabShow ? (
                  <div className="mobile-tab-view-section">
                    <div className="both-drop-down-section">
                      <div className="drop-down-section">
                        <DropDown
                          data={extractTabTitle(PracticeTestData)}
                          setDropDownSelection={setMobileDropDownValue}
                          defaultSelected={mobileDropDownValue}
                        />
                      </div>
                      {(isSingleSectionShow || isFullLengthShow) && (
                        <div className={classNames("second-drop-down-section")}>
                          <DropDown
                            data={
                              isSingleSectionShow
                                ? PracticeTestData.SingleSectionTests !== null
                                  ? Array.from(
                                      new Set(
                                        PracticeTestData.SingleSectionTests.map(
                                          (item: any) => item.ExamGroupName
                                        )
                                      )
                                    )
                                  : []
                                : PracticeTestData.FullLengthTests !== null
                                ? Array.from(
                                    new Set(
                                      PracticeTestData.FullLengthTests.map(
                                        (item: any) => item.ExamGroupName
                                      )
                                    )
                                  )
                                : []
                            }
                            setDropDownSelection={setSecondMobileDropDownValue}
                            defaultSelected={secondMobileDropDownValue}
                            placeholder="Select"
                          />
                        </div>
                      )}
                    </div>

                    {PracticeTestData.RequiredTests !== null
                      ? !isSingleSectionFilterSet &&
                        !isFullLengthFilterSet &&
                        isRequiredShow &&
                        PracticeTestData.RequiredTests &&
                        PracticeTestData.RequiredTests.map(
                          (item: any, index: any) => (
                            <div
                              className="content-section"
                              onClick={() => handleMobileTest(item)}
                              key={index}
                            >
                              <MobileTextIcon
                                textIconLabel={item.Name}
                                iconType={
                                  item.Status === "Lock" ||
                                  item.IsLocked === true
                                    ? "lock"
                                    : item.Status === "Completed"
                                    ? "select"
                                    : item.Status === "InProgress"
                                    ? "yellow-timer"
                                    : "empty-circle"
                                }
                                isCustom={true}
                                theme={theme}
                              />
                            </div>
                          )
                        )
                      : ""}

                    {PracticeTestData.AamcTests !== null
                      ? !isSingleSectionFilterSet &&
                        !isFullLengthFilterSet &&
                        isAamcShow &&
                        PracticeTestData.AamcTests &&
                        PracticeTestData.AamcTests &&
                        PracticeTestData.AamcTests.map(
                          (item: any, index: any) => (
                            <div
                              className="content-section"
                              onClick={() => handleMobileTest(item)}
                              key={index}
                            >
                              <MobileTextIcon
                                textIconLabel={item.Name}
                                iconType={
                                  item.Status === "Lock" ||
                                  item.IsLocked === true
                                    ? "lock"
                                    : item.Status === "Completed"
                                    ? "select"
                                    : item.Status === "InProgress"
                                    ? "yellow-timer"
                                    : "empty-circle"
                                }
                                isCustom={true}
                                theme={theme}
                              />
                            </div>
                          )
                        )
                      : ""}

                    {PracticeTestData.FullLengthTests !== null
                      ? !isSingleSectionFilterSet &&
                        !isFullLengthFilterSet &&
                        isFullLengthShow &&
                        PracticeTestData.FullLengthTests &&
                        PracticeTestData.FullLengthTests.map(
                          (item: any, index: any) => (
                            <div
                              className="content-section"
                              onClick={() => handleMobileTest(item)}
                              key={index}
                            >
                              <MobileTextIcon
                                textIconLabel={item.Name}
                                iconType={
                                  item.Status === "Lock" ||
                                  item.IsLocked === true
                                    ? "lock"
                                    : item.Status === "Completed"
                                    ? "select"
                                    : item.Status === "InProgress"
                                    ? "yellow-timer"
                                    : "empty-circle"
                                }
                                isCustom={true}
                                theme={theme}
                              />
                            </div>
                          )
                        )
                      : ""}
                    {PracticeTestData.SingleSectionTests !== null
                      ? !isSingleSectionFilterSet &&
                        !isFullLengthFilterSet &&
                        isSingleSectionShow &&
                        PracticeTestData.SingleSectionTests &&
                        PracticeTestData.SingleSectionTests.map(
                          (item: any, index: any) => (
                            <div
                              className="content-section"
                              onClick={() => handleMobileTest(item)}
                              key={index}
                            >
                              <MobileTextIcon
                                textIconLabel={item.Name}
                                iconType={
                                  item.Status === "Lock" ||
                                  item.IsLocked === true
                                    ? "lock"
                                    : item.Status === "Completed"
                                    ? "select"
                                    : item.Status === "InProgress"
                                    ? "yellow-timer"
                                    : "empty-circle"
                                }
                                isCustom={true}
                                theme={theme}
                              />
                            </div>
                          )
                        )
                      : ""}

                    {PracticeTestData.SingleSectionTests !== null
                      ? isSingleSectionFilterSet &&
                        !isFullLengthFilterSet &&
                        isSingleSectionShow &&
                        PracticeTestData.SingleSectionTests &&
                        PracticeTestData.SingleSectionTests.filter(
                          (item: any) =>
                            item.ExamGroupName === secondDropDownValue
                        ).map((filterItem: any, index: any) => (
                          <div
                            className="content-section"
                            onClick={() => handleMobileTest(filterItem)}
                            key={index}
                          >
                            <MobileTextIcon
                              textIconLabel={filterItem.Name}
                              iconType={
                                filterItem.Status === "Lock" ||
                                filterItem.IsLocked === true
                                  ? "lock"
                                  : filterItem.Status === "Completed"
                                  ? "select"
                                  : filterItem.Status === "InProgress"
                                  ? "yellow-timer"
                                  : "empty-circle"
                              }
                              theme={theme}
                            />
                          </div>
                        ))
                      : ""}

                    {PracticeTestData.FullLengthTests !== null
                      ? !isSingleSectionFilterSet &&
                        isFullLengthFilterSet &&
                        isFullLengthShow &&
                        PracticeTestData.FullLengthTests &&
                        PracticeTestData.FullLengthTests.filter(
                          (item: any) =>
                            item.ExamGroupName === secondDropDownValue
                        ).map((filterItem: any, index: any) => (
                          <div
                            className="content-section"
                            onClick={() => handleMobileTest(filterItem)}
                            key={index}
                          >
                            <MobileTextIcon
                              textIconLabel={filterItem.Name}
                              iconType={
                                filterItem.Status === "Lock" ||
                                filterItem.IsLocked === true
                                  ? "lock"
                                  : filterItem.Status === "Completed"
                                  ? "select"
                                  : filterItem.Status === "InProgress"
                                  ? "yellow-timer"
                                  : "empty-circle"
                              }
                              theme={theme}
                            />
                          </div>
                        ))
                      : ""}
                  </div>
                ) : null
              ) : isTabShow ? (
                <div className="tab-section">
                  <Tab
                    tabTitles={extractTabTitle(PracticeTestData)}
                    tabContents={Object.keys(PracticeTestData)
                      .filter(
                        (category: string) =>
                          PracticeTestData[category] &&
                          Array.isArray(PracticeTestData[category]) &&
                          PracticeTestData[category].length > 0
                      )
                      .map((title: string, index: number) => {
                        return (
                          <TabPracticeContent
                            key={index}
                            theme={theme}
                            isBtn={true}
                            isMobile={
                              screen.width < MOBILE_WIDTH ||
                              hasSmallScreenWithChatDrawerOpen
                            }
                            isPractice={true}
                            tabNo={index}
                            data={
                              PracticeTestData[title]
                                ? PracticeTestData[title]
                                : []
                            }
                            label={extractTabTitle(PracticeTestData)[index]}
                            {...(title === "FullLengthTests" ||
                            title === "SingleSectionTests"
                              ? {
                                  dropDownData: PracticeTestData[title]
                                    ? Array.from(
                                        new Set(
                                          PracticeTestData[title].map(
                                            (item: any) => item.ExamGroupName
                                          )
                                        )
                                      )
                                    : [],
                                }
                              : {})}
                          />
                        );
                      })}
                    defaultActiveTab={0}
                  />
                </div>
              ) : null}
            </>
          )
        )}
      </div>
      <Modal isOpen={isModalOpen} onClose={handleModalClose} theme={"light"}>
        <div className="practice-modal-wrapper">
          <div
            className="header"
            style={
              theme === "light"
                ? { backgroundColor: "#233851" }
                : { backgroundColor: "#329EE2" }
            }
          >
            <div className="header-topic">
              <Typography
                label={
                  modalSelector === "both"
                    ? "Select Your Desired Test Format"
                    : "Paper and Pencil Test"
                }
                variant="h4Bold"
                styles={
                  theme === "light"
                    ? "title-typography-custom-style-light"
                    : "title-typography-custom-style-dark"
                }
              />
            </div>
            <div className="close-icon" onClick={handleModalClose}>
              <CloseIcon theme={theme} />
            </div>
          </div>
          <div
            className="body"
            style={
              theme === "dark"
                ? { backgroundColor: "#1c1f23" }
                : { backgroundColor: "#ffffff" }
            }
          >
            {modalSelector === "both" &&
            selectedItem &&
            selectedItem.LaunchTests[0] ? (
              <PracticeModalInnerCard
                theme={theme}
                modalSelector={modalSelector}
                type="online"
                isPdfUrl={selectedItem.PdfUrl}
                title="Online"
                description="Complete all the questions in this section and see your results and the explanations at the end"
                btnLabel="Launch Online Test"
                launchUrl={
                  selectedItem.LaunchTests && selectedItem.LaunchTests[0]
                    ? selectedItem.LaunchTests[0].DeliveryType === "Online"
                      ? selectedItem.LaunchTests[0].LaunchUrl
                      : selectedItem.LaunchTests[1] &&
                        selectedItem.LaunchTests[1].LaunchUrl
                      ? selectedItem.LaunchTests[1].LaunchUrl
                      : ""
                    : ""
                }
                handleModalClose={handleModalClose}
                handleRefreshModalOpen={handleRefreshModalOpen}
              />
            ) : null}

            {selectedItem ? (
              <PracticeModalInnerCard
                theme={theme}
                modalSelector={modalSelector}
                type="bubble-sheet"
                isPdfUrl={selectedItem.PdfUrl}
                pdfUrl={selectedItem.PdfUrl}
                title="Bubblesheet"
                description="Complete all the questions in this section by entering your answers in a bubblesheet"
                btnLabel="Launch Bubblesheet"
                onlineProctor_1={onlineProctor_1}
                onlineProctor_2={onlineProctor_2}
                onlineProctor_3={onlineProctor_3}
                launchUrl={
                  selectedItem.LaunchTests &&
                  selectedItem.LaunchTests[0] &&
                  selectedItem.LaunchTests[0].LaunchUrl
                    ? modalSelector === "both" &&
                      selectedItem.LaunchTests[1] &&
                      selectedItem.LaunchTests[1].LaunchUrl
                      ? selectedItem.LaunchTests[0].DeliveryType === "Online"
                        ? selectedItem.LaunchTests[1].LaunchUrl
                        : selectedItem.LaunchTests[0].LaunchUrl
                      : selectedItem.LaunchTests[0].LaunchUrl
                    : ""
                }
                handleModalClose={handleModalClose}
                handleRefreshModalOpen={handleRefreshModalOpen}
              />
            ) : null}
          </div>
        </div>
      </Modal>
      <RefreshModal
        theme={theme}
        handleOnClose={handleRefreshModalClose}
        isOpen={isRefreshModalOpen.isOpen}
        handleRefresh={handleRefresh}
        contentObjectType={
          isRefreshModalOpen.data !== "" ? isRefreshModalOpen.data : "test"
        }
        isFetching={
          PracticeTestIsFetching ||
          graphDataIsFetching ||
          isFetchingCoursework ||
          isfetchingTestScores ||
          isFetchingOverallProgress
        }
      />
    </>
  );
};
